import MoneyField from '@admin/components/form/moneyfield'
import Container from '@admin/components/container'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import moment from 'moment'
import React from 'react'

class InvoicesField extends React.PureComponent {

  static propTypes = {
    contact: PropTypes.object,
    defaultValue: PropTypes.array,
    invoices: PropTypes.array,
    onReady: PropTypes.func,
    onChange: PropTypes.func
  }

  state = {
    allocations: null
  }

  _handleSet = this._handleSet.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    const { allocations } = this.state
    const { invoices } = this.props
    if(!allocations) return null
    return (
      <div className="invoicesfield">
        <table className="ui unstackable celled table">
          <thead>
            <tr>
              <th>Invoice</th>
              <th>Date</th>
              <th className="collapsing">Balance</th>
              <th className="collapsing">Amount</th>
            </tr>
          </thead>
          <tbody>
            { invoices.map((invoice, index) => [
              <tr key={`allocation_${index}`}>
                <td>{ invoice.id }</td>
                <td>{ moment(invoice.date).format('MM/DD/YYYY') }</td>
                <td className="right aligned">{ numeral(invoice.balance).format('0.00') }</td>
                <td><MoneyField { ...this._getMoneyField(index) } /></td>
              </tr>
            ]) }
          </tbody>
          <tfoot>
            <tr>
              <th colSpan="3">Total</th>
              <td className="right aligned">{ numeral(this._getTotal()).format('0.00') }</td>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  componentDidMount() {
    const { invoices } = this.props
    this._handleSet(invoices.map(invoice => ({
      invoice_id: invoice.id,
      amount: Number(invoice.balance)
    })))
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { allocations } = this.state
    if(!_.isEqual(allocations, prevState.allocations)) {
      this._handleChange()
    }
  }

  _getMoneyField(index) {
    const { allocations } = this.state
    return {
      defaultValue: allocations[index].amount,
      deselectable: false,
      showCurrency: false,
      onChange: this._handleUpdate.bind(this, index)
    }
  }

  _getTotal() {
    const { allocations } = this.state
    return allocations.reduce((sum, allocation) => sum + allocation.amount, 0)
  }

  _handleChange() {
    const { allocations } = this.state
    this.props.onChange(allocations)
  }

  _handleSet(allocations) {
    this.setState({ allocations })
  }

  _handleUpdate(index, amount) {
    const { allocations } = this.state
    this.setState({
      allocations: allocations.map((allocation, i) => ({
        ...i === index ? {
          invoice_id: allocation.invoice_id,
          amount
        } : allocation
      }))
    })
  }

}

const mapResources = (props, context) => ({
  invoices: {
    endpoint: '/api/admin/finance/invoices',
    filter: {
      contact_id: { $eq: props.contact.id },
      status: { $nin: ['paid','voided'] }
    }
  }
})

export default Container(mapResources)(InvoicesField)
